import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Get language from localStorage
  const lang = localStorage.getItem("lang") || "en";

  // Define translations
  const t = {
    en: {
      login: "Login",
      email: "E-mail",
      emailPlaceholder: "Enter your email",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      loginBtn: "Login",
      forgotPassword: "Forgot Password?",
      noAccount: "Don't have an account?",
      registerHere: "Register here",
      loginSuccess: "Login successful!",
      loginFailed: "Login failed",
      unknownError: "Unknown error",
      loginError: "An error occurred during login.",
    },
    bn: {
      login: "লগইন",
      email: "ই-মেইল",
      emailPlaceholder: "আপনার ই-মেইল লিখুন",
      password: "পাসওয়ার্ড",
      passwordPlaceholder: "আপনার পাসওয়ার্ড লিখুন",
      loginBtn: "লগইন",
      forgotPassword: "পাসওয়ার্ড ভুলে গেছেন?",
      noAccount: "আপনার কোনো অ্যাকাউন্ট নেই?",
      registerHere: "এখানে নিবন্ধন করুন",
      loginSuccess: "লগইন সফল হয়েছে!",
      loginFailed: "লগইন ব্যর্থ হয়েছে",
      unknownError: "অজানা ত্রুটি",
      loginError: "লগইনের সময় একটি ত্রুটি ঘটেছে।",
    },
  }[lang]; // Choose language object

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      navigate("/overview");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const result = await response.json();

      if (!result.error && result.data?.JWTtoken) {
        const token = result.data.JWTtoken;
        localStorage.setItem("jwtToken", token);
        navigate("/overview");
        window.location.reload();
      } else {
        /* alert(`${t.loginFailed}: ${result.msg || t.unknownError}`); */
        setError(`${result.msg || t.unknownError}`);
      }
    } catch (error) {
      console.error("Login error:", error);
      /* alert(t.loginError); */
      setError(t.loginError);
    }
  };

  return (
    <div className={`login ${lang === "bn" ? "bn-font" : ""}`}>
      <h2 className="login-title">{t.login}</h2>
      <form className="login" onSubmit={handleSubmit}>
        <div className="input-box">
          <label className="input-title" htmlFor="email">
            {t.email}
          </label>
          <input
            id="email"
            className="input-field"
            type="email"
            placeholder={t.emailPlaceholder}
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-box">
          <label className="input-title" htmlFor="password">
            {t.password}
          </label>
          <input
            id="password"
            className="input-field"
            type="password"
            placeholder={t.passwordPlaceholder}
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div style={{ color: "red" }}>{error}</div>

        <button className="navbar-login-button" type="submit">
          {t.loginBtn}
        </button>
        <div className="forgot-password">
          <a href="/forgot-password">{t.forgotPassword}</a>
          <div>
            {t.noAccount} <a href="/register">{t.registerHere}</a>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Login;
